<template>
  <v-dialog v-model="dialog" :width="progress ? 500 : 1300">
    <v-card style="border:1px solid white;">
      <v-card-title
        class=" align-center back-556C96 text-center justify-center color-white mb-3"
      >
        <h3>{{ title }}</h3>
      </v-card-title>
      <div v-if="!progress">
        <v-row class="ma-0 pl-5 pt-5 pb-4">
          <h3>
            {{ "현장명 : " + constructionName.constructionName }}
          </h3>
        </v-row>
        <v-row class="ma-0 pl-5 pa-0">
          <h4>
            SMS로 발송 할 발주 데이터를 선택해주세요.
          </h4>
        </v-row>
        <v-row
          class="ma-0 pl-5 pa-0 align-center"
          v-if="
            (userType == '현장관리자' || userType == '시스템관리자') &&
              status == 'order'
          "
        >
          <v-radio-group
            v-model="radioGroup"
            row
            hide-details
            class="ma-0 pa-0 mt-2 mb-5"
          >
            <span class="radio-text" v-if="userType == '시스템관리자'"
              >승인요청</span
            >
            <v-radio
              value="승인요청"
              class="ma-0 pa-0"
              color="#0D99FF"
              v-if="userType == '시스템관리자'"
            >
            </v-radio>
            <span class="radio-text">수정요청</span>
            <v-radio value="수정요청" class="ma-0 pa-0" color="#0D99FF">
            </v-radio>
            <span class="radio-text">승인</span>
            <v-radio value="승인" class="ma-0 pa-0" color="#0D99FF"> </v-radio>
          </v-radio-group>
        </v-row>
        <v-row class="ma-0 pl-5 justify-center  pa-0">
          <v-simple-table height="480" fixed-header>
            <thead class=" text-center">
              <tr class="text-md-center color-white ">
                <th
                  rowspan="2"
                  class="text-md-center color-white border-right back-8ca9dd"
                >
                  선택
                </th>
                <th
                  rowspan="2"
                  class="text-md-center color-white border-right back-8ca9dd"
                >
                  {{ this.status == "order" ? "발주차수" : "출고차수" }}
                </th>
                <th
                  rowspan="2"
                  class="text-md-center color-white border-right back-8ca9dd"
                >
                  부위
                </th>
                <th
                  :colspan="materialList.length"
                  class="text-md-center color-white  border-right-white  back-8ca9dd "
                >
                  규격(단위:TON)
                </th>
                <th rowspan="2" class="color-white back-8ca9dd  text-center">
                  발주수량
                </th>
              </tr>
              <tr>
                <th
                  v-for="material in materialList"
                  :key="material.rebar_id"
                  class="border-right-white border-top-white back-8ca9dd color-white text-center"
                >
                  {{ material.rebar_name }}
                </th>
              </tr>
            </thead>
            <tbody v-if="status == 'order'">
              <tr v-for="(material, i) in totalList" :key="material.orderId">
                <td
                  class="justify-center align-center border-left-aaaaaa border-bottom-aaaaaa"
                >
                  <input type="checkbox" v-model="checkboxList[i]" />
                </td>

                <td
                  class="justify-center text-md-center border-bottom-aaaaaa  border-left-aaaaaa"
                >
                  {{ material.orderName }}
                </td>
                <td
                  class="justify-center text-md-center border-bottom-aaaaaa  border-left-aaaaaa"
                >
                  {{ material.partName }}
                </td>
                <td
                  class="justify-center text-md-center border-bottom-aaaaaa  border-left-aaaaaa"
                  v-for="(rebar, index) in material.rebarList"
                  :key="index"
                >
                  {{ mathRound(rebar) }}
                </td>
                <td
                  class="justify-center text-md-center border-bottom-aaaaaa  border-left-aaaaaa border-right-aaaaaa"
                >
                  {{ sum(material.rebarList) }}
                </td>
              </tr>
            </tbody>
            <tbody v-else-if="status == 'invoice'">
              <tr v-for="(material, i) in totalList" :key="material.invoiceId">
                <td
                  class="justify-center d-flex align-center border-left-aaaaaa"
                >
                  <input type="checkbox" v-model="checkboxList[i]" />
                </td>

                <td class="justify-center text-md-center border-left-aaaaaa">
                  {{ material.invoiceCode }}
                </td>
                <td class="justify-center text-md-center border-left-aaaaaa">
                  <v-btn class="disable-btn" text max-width="330" disabled>
                    {{ material.partName }}
                  </v-btn>
                </td>
                <td
                  class="justify-center text-md-center border-left-aaaaaa"
                  v-for="(invoice, index) in material.regacyInvoiceSumList"
                  :key="index"
                >
                  {{ mathRound(invoice).toFixed(3) }}
                </td>
                <td
                  class="justify-center text-md-center border-left-aaaaaa border-right-aaaaaa"
                >
                  {{ mathRound(material.allSum).toFixed(3) }}
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-row>
      </div>
      <v-row v-else class="pa-0 ma-0  justify-center">
        <perfect-scrollbar style="max-height:430px">
          <div
            v-for="(userlists, index) in userTotalList"
            :key="userlists.constructionAdminId"
          >
            <input
              v-model="checkList[index]"
              type="checkbox"
              class="mr-2 border-ra-5"
            />
            {{ userlists.companyName + " / " + userlists.constructionAdmin }}
          </div>
        </perfect-scrollbar>
      </v-row>
      <v-row class="justify-center ma-0 pb-5 mt-5">
        <v-btn
          color="#739EEC"
          class="color-white mr-3"
          width="150"
          height="40"
          @click="smsCheck"
          v-if="!progress"
        >
          확인</v-btn
        >
        <v-btn
          color="#EEEEEE"
          width="150"
          height="40"
          @click="dialog = false"
          v-if="!progress"
        >
          닫기</v-btn
        >
        <v-btn
          color="#739EEC"
          class="color-white mr-3"
          width="150"
          height="40"
          @click="smsSend"
          v-if="progress"
        >
          확인</v-btn
        >
        <v-btn
          color="#eeeeee"
          width="150"
          height="40"
          @click="resetSms"
          v-if="progress"
        >
          뒤로가기</v-btn
        >
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
import invoiceApi from "../api/InvoiceService";
import OrderApi from "../api/OrderService";
import SmsApi from "../api/SMSService";
import Commonality from "../mixin/Commonality";
import { PerfectScrollbar } from "vue2-perfect-scrollbar";
import "vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css";

export default {
  components: {
    PerfectScrollbar,
  },
  mixins: [Commonality],
  data: () => ({
    dialog: false,
    checkboxList: [],
    totalList: [],
    status: "",
    sendList: [],
    userList: [],
    userTotalList: [],
    progress: false,
    checkList: [],
    radioGroup: "승인요청",
  }),
  created() {
    if (this.userType == "현장관리자") {
      this.radioGroup = "수정요청";
    }
    this.$bus.$on("smsOpen", async (state) => {
      this.dialog = true;
      this.checkboxList = [];
      this.status = state;
      let data = {
        constructionId: this.constructionId,
        smsType:
          this.radioGroup == "승인요청"
            ? "S"
            : this.radioGroup == "수정요청"
            ? "N"
            : this.radioGroup == "승인"
            ? "Y"
            : null,
      };
      let returnData = [];
      if (state == "order") {
        this.status = "order";
        returnData = await OrderApi.orderTotalList(data);
        this.totalList = returnData.data.orderList;
      } else {
        this.status = "invoice";
        returnData = await invoiceApi.invoiceTotalList(data);
        this.totalList = returnData.data.invoiceList;
      }
    });
  },
  beforeDestroy() {
    this.$bus.$off("smsOpen");
  },
  computed: {
    userInfo() {
      return this.$store.getters.getUserList;
    },
    userType() {
      if (this.userInfo) return this.userInfo.roleType;
    },
    companyType() {
      if (this.userInfo) return this.userInfo.companyType;
    },
    title() {
      return this.status == "order"
        ? this.progress
          ? "발주 SMS 수신자 선택"
          : "발주 SMS 발송 차수 선택"
        : this.progress
        ? "출고 SMS 수신자 선택"
        : "출고 SMS 발송 차수 선택";
    },
    smsStatus() {
      if (this.status == "invoice") {
        return "manage";
      } else if (this.companyType == "샵업체") {
        return "manage";
      } else if (this.radioGroup == "승인요청") {
        return "manage";
      } else if (this.radioGroup == "수정요청") {
        return "shop";
      } else if (this.radioGroup == "승인") {
        return "factory";
      }
    },
  },
  watch: {
    dialog(val) {
      if (!val) {
        this.resetSms();
        this.checkboxList = [];
        this.totalList = [];
      }
    },
    async radioGroup(val) {
      if (this.status == "order") {
        let data = {
          constructionId: this.constructionId,
          smsType:
            val == "승인요청"
              ? "S"
              : val == "수정요청"
              ? "N"
              : val == "승인"
              ? "Y"
              : null,
        };
        let returnData = await OrderApi.orderTotalList(data);
        this.totalList = returnData.data.orderList;
      }
    },
  },
  methods: {
    resetSms() {
      this.progress = false;
      this.userTotalList = [];
    },
    async smsCheck() {
      let check = this.checkboxList.filter(
        (checkboxValue) => checkboxValue == true
      );
      if (check.length == 0) {
        this.$bus.$emit("dialog", "발송 차수를 선택해주세요.");
        return;
      }
      if (
        !(this.companyType == "가공업체" || this.companyType == "샵업체") &&
        !this.radioGroup
      ) {
        this.$bus.$emit("dialog", "선택 후 진행해주세요.");
        return;
      }
      //여기서 체크
      this.sendList = [];
      for (let i = 0; i < this.checkboxList.length; i++) {
        if (this.checkboxList[i] == true) {
          if (this.status == "order")
            this.sendList.push(this.totalList[i].orderId);
          else if (this.status == "invoice")
            this.sendList.push(this.totalList[i].invoiceId);
        }
      }
      let data = {
        constructionId: this.constructionId,
        delimiter: this.smsStatus,
      };
      let res = await SmsApi.smsUserList(data);
      if (res.data.success == "fail") {
        this.$bus.$emit(
          "dialog",
          "담당자가 미등록 상태입니다. \n 현장관리 페이지에서 담당자 등록 후 진행해주세요."
        );
        return;
      }
      this.userTotalList = res.data.userlist;
      this.progress = !this.progress;
    },

    async smsSend() {
      if (this.checkList.filter((a) => a == true).length == 0) {
        this.$bus.$emit("dialog", "메세지를 전달할 사람을 선택해주세요.");
        return;
      }
      let datas = {
        constructionId: this.constructionId,
        delimiter: this.status,
        selectedIds: this.sendList,
      };
      let text = "발송이 실패하였습니다. 확인 후 다시 시도 해주세요.";
      try {
        let res;
        for (let i = 0; i < this.checkList.length; i++) {
          if (this.checkList[i]) {
            datas.phoneNumber = this.userTotalList[i].phoneNumber;
            res = await SmsApi.smsSend(datas);
            if (res.data.success == "fail") {
              text = res.data.reason;
              this.dialog = false;
              this.$bus.$emit("dialog", text);
              return;
            }
          }
        }
        text = `현장명 : ${this.constructionName.constructionName} SMS 발송이 완료되었습니다.`;
        this.dialog = false;
        this.$bus.$emit("dialog", text);
      } catch {
        this.dialog = false;
        this.$bus.$emit("dialog", text);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.radio-text {
  color: #000;
  font-size: 15px;
  font-family: Noto Sans KR;
  font-weight: 700;
}

.v-input--radio-group--column .v-input--radio-group__input {
  flex-direction: none;
}

.border-ra-5 {
  border-radius: 5px;
}

.v-data-table {
  overflow-y: hidden;
}

.border-right {
  border-right: thin solid #c4c4c4;
}

.border-left {
  border-left: thin solid #c4c4c4;
}

.border-bottom {
  border-bottom: thin solid #c4c4c4;
}

.disable-btn {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  color: rgba(0, 0, 0, 0.87) !important;
}
</style>
